import { useState, useEffect, useContext } from 'react';

import { LiveReserveContext } from '../../../../../../LiveLessonReseveContext';


// シチュエーションごと:ビジネス
function LiveReserveSituationCaseCategoryBusiness(props: any) {

  const { title } = useContext(LiveReserveContext);

  return (
    <li className="list-group-item text-center">
      <p>
        ビジネスコースの{title}は
        <br className="visible-xs" />
        ご購入後にご利用可能です
      </p>
      <a
        href="/settlement/extension?target=business#business"
        className="btn btn-success"
      >
        ビジネスコースのご購入はコチラ
      </a>
    </li>
  );
}
  
export default LiveReserveSituationCaseCategoryBusiness;